<div class="container-fluid animated fadeIn is-step-wizard">
	<div class="row my-5">
		<!-- STEPS TITLE -->
		<div class="col-12 mb-4">
			<div class="wiz-title">
				{{ 'factoring-credit-assignment-step1.pageTitle' | translate }}
			</div>
		</div>

		<!-- CARD -->
		<div class="col-12">
			<div class="simple-card top-line">
				<div class="row justify-content-center steps-area">
					<!-- STEPS -->
					<div class="col-xl-8">
						<ul class="step p-0">
							<li class="step-item active">
								<a
									href="#"
									class="disabled"
									>{{ 'factoring-credit-assignment.Step1Label' | translate }}</a
								>
							</li>
							<li class="step-item">
								<a
									href="#"
									class="disabled"
									>{{ 'factoring-credit-assignment.Step2Label' | translate }}</a
								>
							</li>
						</ul>
					</div>
					<div class="text-center xs-only">
						<span class="fw-bold is-color-light">{{ 'factoring-credit-assignment.Step1Label' | translate }}</span>
					</div>
				</div>
				<div class="divider"></div>
				<div class="row justify-content-center content-area">
					<div class="col-xl-8">
						<div class="d-flex align-items-start">
							<div>
								<div class="info-img-wrap">
									<div>
										<i class="fa-solid fa-file-download"></i>
									</div>
								</div>
							</div>
							<div class="ms-4">
								<div class="d-flex align-items-center mb-3">
									<div class="round-number">1</div>
									<div
										class="number-title ms-2"
										data-e2e-credit-assignment-template-step-1-title>
										{{ 'factoring-credit-assignment-step1.FactoringCreditAssignmentTemplateTitle' | translate }}
									</div>
								</div>
								<div>
									<ul
										class="step-description"
										data-e2e-credit-assignment-template-step-1-description>
										<li>
											{{ 'factoring-credit-assignment-step1.FactoringCreditAssignmentTemplateInfoText' | translate }}
										</li>
									</ul>
								</div>
								<div>
									<eif-custom-button
										[text]="'factoring-credit-assignment-step1.FactoringCreditAssignmentTemplate' | translate"
										[color]="'success'"
										[preIcon]="'fa-light fa-file-excel'"
										[class]="'mb-0 ms-4'"
										(action)="downloadTemplate()">
									</eif-custom-button>
								</div>
							</div>
						</div>
						<div class="d-flex align-items-start instruction-distance">
							<div>
								<div class="info-img-wrap">
									<div>
										<i class="fa-solid fa-list-ul"></i>
									</div>
								</div>
							</div>
							<div class="ms-4">
								<div class="d-flex align-items-center mb-3">
									<div class="round-number">2</div>
									<div class="number-title ms-2">
										{{ 'factoring-credit-assignment-step1.FactoringCreditAssignmentTemplateInstructionsTitle' | translate }}
									</div>
								</div>
								<div>
									<ul class="step-description">
										<li data-e2e-credit-assignment-template-step-2-instructions-1>
											{{ 'factoring-credit-assignment-step1.FactoringCreditAssignmentTemplateInstructionsInfoText1' | translate }}
										</li>
										<li>
											<span data-e2e-credit-assignment-template-step-2-instructions-2>
												{{ 'factoring-credit-assignment-step1.FactoringCreditAssignmentTemplateInstructionsInfoText2' | translate }}
											</span>
										</li>
										<li>
											<span data-e2e-credit-assignment-template-step-2-instructions-3>
												{{ 'factoring-credit-assignment-step1.FactoringCreditAssignmentTemplateInstructionsInfoText3' | translate }}
											</span>
										</li>
										<li>
											<span data-e2e-credit-assignment-template-step-2-instructions-4>
												{{ 'factoring-credit-assignment-step1.FactoringCreditAssignmentTemplateInstructionsInfoText4' | translate }}
											</span>
										</li>
										<li>
											<span data-e2e-credit-assignment-template-step-2-instructions-5>
												{{ 'factoring-credit-assignment-step1.FactoringCreditAssignmentTemplateInstructionsInfoText5' | translate }}
											</span>
										</li>
										<li>
											<span data-e2e-credit-assignment-template-step-2-instructions-6>
												{{ 'factoring-credit-assignment-step1.FactoringCreditAssignmentTemplateInstructionsInfoText6' | translate }}
											</span>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="divider"></div>
				<!-- BUTTONS AREA -->
				<div class="d-flex align-items-center justify-content-xs-center justify-content-end p-4">
					<div>
						<eif-custom-button
							[text]="'factoring-credit-assignment-step1.goToUploadStep' | translate"
							[postIcon]="'fa-light fa-chevron-right'"
							[class]="'mb-0'"
							(action)="navigateToUploadStep1()">
						</eif-custom-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
